import { QueryKey } from '@/data/query';
import type { MutationOptions } from '@/error-handling/types';
import { useQueryClient } from '@tanstack/react-query';
import { prescribeClient } from '../../api/prescribedProducts/prescribedProductClient';

export const usePrescribePrescriptions = (options?: MutationOptions) => {
  const queryClient = useQueryClient();
  const queryKey = [QueryKey.PrescribePrescription];
  const { mutateAsync, isPending } = prescribeClient.prescribe.useMutation({
    mutationKey: queryKey,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.PrescribedProducts] });
    },
    ...options,
  });

  return { mutateAsync, isPending };
};
